import { useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface PanicButtonModalProps {
  open: boolean;
  theme?: string;
  onGoToCurrentCall: () => void;
  onCreateNewCall: () => void;
  onCancel: () => void;
}

export function PanicButtonModal({
  open,
  theme,
  onGoToCurrentCall,
  onCreateNewCall,
  onCancel,
}: PanicButtonModalProps) {
  const handleGoToCurrentCall = useCallback(() => {
    onGoToCurrentCall();
  }, [onGoToCurrentCall]);

  const handleCreateNewCall = useCallback(() => {
    onCreateNewCall();
  }, [onCreateNewCall]);

  return (
    <BaseFormModal
      open={open}
      title="Panic Button"
      theme={theme}
      showSave={false}
      cancelText="Cancel"
      onCancel={onCancel}
    >
      <button
        type="button"
        className="btn btn-default"
        style={{ marginRight: 8 }}
        onClick={handleGoToCurrentCall}
      >
        Go to Current Panic Call
      </button>
      <button
        type="button"
        className="btn btn-default"
        onClick={handleCreateNewCall}
      >
        Create New Panic Call
      </button>
    </BaseFormModal>
  );
}

(window as any).PanicButtonModalReact = PanicButtonModal;
